import axios from 'axios'

export const BASEURLPROJETOS = axios.create({
  baseURL: process.env.REACT_APP_API_PROJETOS_GESTTOR,
  headers: {
    'Content-Type': 'application/json',
  }

})

export default BASEURLPROJETOS